
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import {
		productMaterialDetail,
		productMaterialSave
	} from '@/api/material';

	import UploadImg from '@/components/upload-img.vue';
	import PageFooter from '@/components/page-footer.vue';
	
	import upload from '@/utils/upload/uploadImg.js';
	import {
		host,
		imgHost
	} from '@/utils/config';
	import vuedraggable from 'vuedraggable';

	@Component({
		name: 'product-material-detail',
		components: {
			UploadImg,
			vuedraggable,
			PageFooter
		}
	})
	export default class ProductMaterialDetail extends Vue {
		private id = +this.$route.query.id;
		private productId = +this.$route.query.productId;
		private formData: any = {
			MaterialCategory: 1, // ['招商素材:1' or '商品素材:2' or '发圈素材:3']: 素材分类,
			Title: '', //标题,
			Copywriting: '', // 素材文案,
			RelationId: '', // 关联Id,
			MaterialType: 0, // (int) = ['图片:0' or '视频:1']: 素材类型,
			Video: '', // 视频,
			ImgUrlList: [], //素材图片
		}
		
		private picHoverIndex = null;
		
		private uploadUrl = host + '/api/image/upload?PlatForm=routuan&Path=image';
		private imgUrl = imgHost;

		private typeList: any = [{
			value: 0,
			label: '图文素材'
		}, {
			value: 1,
			label: '视频素材'
		}]

		private mounted() {
			if (this.id) {
				this.getDetail();
			}
		}

		/**
		 * 获取详情
		 */
		private async getDetail() {
			try {
				const res: any = await productMaterialDetail({
					Id: this.id
				})

				this.formData = res.Result;
			} catch (err) {

			}
		}
		
		/**
		 * 上传钩子
		 */
		private beforeUpload(file: any) {
			console.log(file.type)
			if (this.formData.MaterialType === 0) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isGIF = file.type === 'image/gif';
				if (!isLt2M) {
					this.$message.error('请上传2M以内的图片');
					return false
				}
				if (!isJPG && !isPNG && !isGIF) {
					this.$message.error('上传正确的图片格式!');
					return false
				}
				return true;
			} else {
				const isLt2M = file.size / 1024 / 1024 < 30;
				if(file.type.indexOf('video') < 0){
					this.$message.error('上传正确的视频格式!');
					return false
				}
				if (!isLt2M) {
					this.$message.error('请上传20M以内的视频文件');
					return false
				}
				return true;
			}

		}
		
		/**
		 * 上传成功
		 */
		private handleSuccess(res: any) {
			if (this.formData.MaterialType === 0) {
				this.formData.ImgUrlList.push(res.Result[0])
			} else {
				this.formData.Video = res.Result[0];
			}
		}
		
		/**
		 *	删除图片
		 */
		private handleDeleteImage(index) {
			this.formData.ImgUrlList.splice(index, 1);
			this.picHoverIndex = null;
		}
		
		private toBack() {
			this.$router.go(-1)
		}
		
		private valid(){
			var str = ''
			if (!this.formData.Title){
				str = '请输入素材标题'
			}else if (this.formData.MaterialType === 0 && !this.formData.ImgUrlList.length){
				str = '请上传素材图片'
			}else if (this.formData.MaterialType === 1 && !this.formData.Video){
				str = '请上传素材视频'
			}
			
			if (str){
				this.$message({
					type: 'warning',
					message: str
				})
				return false
			}
			return true;
		}
		
		private async submit(){
			if(!this.valid()) return;
			
			try{
				var params = this.formData;
				params.Id = this.id || 0;
				params.ProductId = this.productId;
				const res = await productMaterialSave(params);
				this.$message({
					type: 'success',
					message: this.id ? '编辑成功' : '创建成功'
				})
				this.toBack()
			}catch(err){
				console.log(err)
			}
		}

	}
